import { ChevronLeft } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import ComponentTable from '../../components/ComponentTable';
import models_V2Service from '../../services/models_V2.service';
import quizService from '../../services/quiz.service';

export const QuizSingleStatisticPage = () => {
    const { id } = useParams();
    const { t } = useTranslation();
    const history = useHistory();

    return (
        <>
            <Button
                onClick={() => history.goBack()}
                startIcon={<ChevronLeft />}
                // variant={'outlined'}
            >
                <Typography>{t('quiz.back').toLocaleUpperCase()}</Typography>
            </Button>
            <Typography component="h2" className="container-header" pb={1}>
                {' '}
                {t('quiz.historyOfQuesions')}{' '}
            </Typography>

            <ComponentTable
                source={{
                    getData: (page, size, sort, filter) =>
                        quizService.GetQuizStatisticSingle(false, {
                            page: page || 0,
                            size: size || 10,
                            orderBy: (sort && sort.orderBy) || 'updated_at',
                            order: (sort && sort.order) || 'asc',
                            quizze_id: id,
                            filter,
                        }),
                    getModel: () => models_V2Service.QuizzesStatisticSingle(false),
                }}
                actions={[]}
                selectable={true}
                enableFilter={true}
                title={t('modals.list')}
                enableSettings
                toolbarvisible={true}
                typeTable="quizzes_statistic"
            />
        </>
    );
};
